import { render, staticRenderFns } from "./RelatorioSaida.vue?vue&type=template&id=780c3277"
import script from "./RelatorioSaida.vue?vue&type=script&lang=js"
export * from "./RelatorioSaida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports